"use client";
import Link from "next/link";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

const images = [
  "/assets/images/page/service/wemap/mainPage01.png",
  "/assets/images/page/service/wemap/mainPage02.png",
];

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};
export default function AppMainSection() {
  return (
    <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-4 md:py-20">
      {/* 타이틀 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <div className="flex flex-row items-center mb-14 md:mb-20">
          <span
            className="text-lg text-white mr-4 md:mr-10 w-9 h-9 md:w-11 md:h-11 rounded-lg md:rounded-2xl bg-[#DA6363] items-center flex justify-center"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            2
          </span>
          <p
            className="text-xl md:text-3xl text-[#2E2E2E]"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            메인페이지
          </p>
        </div>
      </motion.div>
      <motion.div
        className="flex flex-col"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <motion.p
          className="mt-5 md:mt-12 xl:mt-16  text-2xl md:text-3xl xl:text-4xl text-black-almostBlack leading-8 md:leading-12 tracking-tight"
          style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          variants={{
            hidden: { opacity: 0, y: 10 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5 }}
        >
          카테고리별로 정리된 장소 편의시설!
        </motion.p>
        <motion.p
          className="text-base md:text-xl xl:text-2xl xl:leading-9  md:leading-8 leading-6 mt-5 text-black-100 tracking-tight"
          variants={{
            hidden: { opacity: 0, y: 10 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5 }}
          style={{ fontFamily: '"pre-Medium", sans-serif' }}
        >
          식당부터 입간판경사로, 문화/관광까지
          <br />
          필요한 정보를 더 빠르게 확인하세요.
        </motion.p>
      </motion.div>
      <motion.div
        className="flex flex-col md:flex-row justify-between space-y-5 md:space-y-0  space-x-0 md:space-x-5 my-10 md:my-20"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {images.map((src, idx) => (
          <motion.div
            key={idx}
            variants={itemVariants}
            className="relative flex grow rounded-xl md:rounded-3xl overflow-hidden"
          >
            <Image
              src={src}
              alt={`app screen ${idx + 1}`}
              width={300}
              height={533}
              className="w-full h-auto object-contain"
              priority={idx === 0} // 첫 이미지만 미리 로드
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
